(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nau-tips-from-the-pros"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nau-pro-guides')) {
    customElements.define('nau-pro-guides', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => this.onClick(event), options);
        this.addEventListener('keydown', (event) => this.onKeydown(event), options);
        this.addEventListener('close', (event) => this.onClose(event), { ...options, capture: true });
        this.addEventListener('pointerdown', (event) => {
          this.backdropPointer = this.isBackdrop(event);
        }, options);
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), options);
        document.addEventListener('shopify:section:deselect', (event) => {
          if (String(event.detail.sectionId) === this.dataset.sectionId) this.closeAll();
        }, options);
      }

      disconnectedCallback() {
        this.closeAll();
        this.controller?.abort();
        this.controller = null;
        this.unlockPage();
      }

      isBackdrop(event) {
        const dialog = event.target;
        if (!dialog.matches?.('dialog.nau-pro-guides__dialog[open]')) return false;
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      onClick(event) {
        const trigger = event.target.closest('[data-nau-open]');
        if (trigger) {
          const dialog = document.getElementById(trigger.dataset.nauOpen);
          if (dialog && this.contains(dialog)) this.openDialog(dialog, trigger);
          return;
        }
        const close = event.target.closest('[data-nau-close]');
        if (close) { close.closest('dialog').close(); return; }
        const tab = event.target.closest('[data-nau-fabric-tab]');
        if (tab) { this.activateFabric(tab); return; }
        if (this.backdropPointer && this.isBackdrop(event)) event.target.close();
        this.backdropPointer = false;
      }

      loadImages(container) {
        container.querySelectorAll('template[data-nau-image-template]').forEach((template) => {
          template.replaceWith(template.content.cloneNode(true));
        });
      }

      openDialog(dialog, trigger) {
        if (typeof dialog.showModal !== 'function') return;
        if (!dialog.open) {
          this.closeAll();
          dialog.nauOpener = trigger || document.activeElement;
          dialog.showModal();
          document.documentElement.classList.add('nau-pro-guides-lock');
        }
        if (dialog.hasAttribute('data-nau-fabric-dialog')) {
          const tabs = Array.from(dialog.querySelectorAll('[data-nau-fabric-tab]'));
          const selected = tabs.find((tab) => tab.dataset.fabricKey === this.dataset.defaultFabric) || tabs[0];
          if (selected) this.activateFabric(selected);
        } else {
          this.loadImages(dialog);
        }
      }

      activateFabric(tab, moveFocus = false) {
        const dialog = tab.closest('dialog');
        const id = tab.dataset.nauFabricTab;
        dialog.querySelectorAll('[data-nau-fabric-tab]').forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        dialog.querySelectorAll('[data-nau-fabric-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.nauFabricPanel !== id;
        });
        dialog.querySelectorAll('[data-nau-fabric-image]').forEach((image) => {
          image.hidden = image.dataset.nauFabricImage !== id;
          if (!image.hidden) this.loadImages(image);
        });
        if (moveFocus) tab.focus({ preventScroll: true });
        if (dialog.open) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-nau-fabric-tab]');
        if (!tab || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
        let index = tabs.indexOf(tab);
        const rtl = getComputedStyle(tab).direction === 'rtl';
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1) + tabs.length) % tabs.length;
        event.preventDefault();
        this.activateFabric(tabs[index], true);
      }

      onClose(event) {
        if (!event.target.matches('dialog.nau-pro-guides__dialog')) return;
        this.unlockPage();
        const opener = event.target.nauOpener;
        if (!this.querySelector('dialog[open]') && opener?.isConnected) opener.focus({ preventScroll: true });
      }

      closeAll() { this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close()); }

      unlockPage() {
        if (!document.querySelector('dialog.nau-pro-guides__dialog[open]')) document.documentElement.classList.remove('nau-pro-guides-lock');
      }

      onBlockSelect(event) {
        if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
        const id = String(event.detail.blockId);
        const tab = Array.from(this.querySelectorAll('[data-nau-fabric-tab]')).find((item) => item.dataset.nauFabricTab === id);
        if (tab) {
          this.openDialog(tab.closest('dialog'));
          this.activateFabric(tab, true);
        } else {
          this.closeAll();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
